export const apiObj = {
  orderSchedule : "4b030175-4971-4b12-8fd8-65ae7d85eab7/query?parameters=%5B%5D", // 订单轮播进度
  yield : "3ce94213-d4e2-4a78-876a-1db21a78647c/query?parameters=%5B%5D", // 每日产量
  process:"323aee00-a673-4b72-b82d-1c1ddb1c89bd/query?parameters=%5B%5D", // 今日工艺统计
  inventory:"4d1b2f33-df11-40ee-9687-af7f54f6277d/query?parameters=%5B%5D", // 库存实时统计
  areaWarning:"5e155658-41c9-4469-83f7-54ebb64969c2/query?parameters=%5B%5D", // 超时警报统计
} 